bam-blog-teaser {
  .bam-blog-teaser__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    bal-button {
      white-space: nowrap;
    }

    @include mobile() {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 0 !important;

      bal-heading {
        margin-bottom: 1rem !important;
      }
    }
  }

  .masonary-grid {
    position: relative;
    width: 100%;

    @include desktop() {
      bam-blog-teaser-item {
        .bal-card-content {
          height: 390px;

          .bal-card-content-text {
            display: flex;
            flex-direction: column;

            .bal-button {
              display: block;
              margin-top: auto !important;
            }
          }
        }

        &[app-widget] {
          .bal-card-content {
            height: 411px;
          }
        }
      }

      bam-blog-teaser-item.with-image {
        .bal-card-content {
          height: 384px;
        }

        &[app-widget] {
          .bal-card-content {
            height: 436px;
          }
        }
      }
    }

    @include widescreen() {
      bam-blog-teaser-item {
        .bal-card-content {
          height: 334px;
        }
        &[app-widget] {
          .bal-card-content {
            height: 370px;
          }
        }
      }

      bam-blog-teaser-item.with-image {
        .bal-card-content {
          height: 323px;
        }
        &[app-widget] {
          .bal-card-content {
            height: 365px;
          }
        }
      }
    }
  }

  .bam-blog-teaser__load-more-btn-wrapper {
    margin-top: 3rem;
    flex-direction: column;
    align-items: center;

    @include mobile {
      &.has-cta-btn > *:nth-child(2) {
        margin-top: 1rem;
      }
    }

    @include tablet() {
      margin-top: 4rem;
      flex-direction: row;

      &.has-cta-btn > *:nth-child(2) {
        margin-left: 1rem;
      }
    }
  }
}
